import { render, staticRenderFns } from "./questionTypePhoneNumber.vue?vue&type=template&id=25c3d356&scoped=true&"
import script from "./questionTypePhoneNumber.vue?vue&type=script&lang=js&"
export * from "./questionTypePhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./questionTypePhoneNumber.vue?vue&type=style&index=0&id=25c3d356&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c3d356",
  null
  
)

export default component.exports